// Central status maps. Labels are resolved via i18n in the components using the
// `key` field together with the `t()` translation function (namespaces
// `status.*` and `kitchenStatus.*`). Only styling info lives here.
export const TABLE_STATUS = {
  free: { key: 'free', color: 'pos-free', dot: 'bg-pos-free' },
  ordered: { key: 'ordered', color: 'pos-ordered', dot: 'bg-pos-ordered' },
  bill_requested: { key: 'billRequested', color: 'pos-bill', dot: 'bg-pos-bill' },
  // legacy alias: "occupato" si comporta esattamente come "ordinato"
  occupied: { key: 'occupied', color: 'pos-ordered', dot: 'bg-pos-ordered' },
};

// Stati mostrati nella legenda dei Tavoli ("Occupato" escluso perché duplica "Ordinato")
export const TABLE_STATUS_LEGEND = ['free', 'ordered', 'bill_requested'];

export const KITCHEN_STATUS = {
  pending: { key: 'pending', color: 'text-muted-foreground' },
  preparing: { key: 'preparing', color: 'text-kds-preparing' },
  ready: { key: 'ready', color: 'text-kds-ready' },
  delivered: { key: 'delivered', color: 'text-kds-delivered' },
};

// i18n label helpers
export const tableStatusLabel = (t, status) => t(`status.${(TABLE_STATUS[status] || TABLE_STATUS.free).key}`);
export const kitchenStatusLabel = (t, status) => t(`kitchenStatus.${(KITCHEN_STATUS[status] || KITCHEN_STATUS.pending).key}`);

export const ROLE_LABELS = {
  admin: 'Amministratore',
  manager: 'Manager',
  cashier: 'Cassiere',
  waiter: 'Cameriere',
};

export const fmtEur = (n) => `\u20ac ${Number(n || 0).toFixed(2)}`;
